export default "__VITE_ASSET__BTNxpPTM__"